// Sloupce odkazů v patičce: na desktopu trvale rozbalené, na mobilu akordeon.
// Stav [open] se přepíná podle breakpointu (styly viz component-footer-bar.css).
(() => {
  const mediaQuery = window.matchMedia('(min-width: 750px)');

  const syncDisclosures = () => {
    document.querySelectorAll('details[data-footer-disclosure]').forEach((disclosure) => {
      disclosure.open = mediaQuery.matches;
    });
  };

  mediaQuery.addEventListener('change', syncDisclosures);
  document.addEventListener('shopify:section:load', syncDisclosures);
  syncDisclosures();
})();
